(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["au-launch-demo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('au-demo-player')) {
    customElements.define('au-demo-player', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        this.toggle = this.querySelector('[data-demo-toggle]');
        this.errorLink = this.querySelector('[data-demo-error]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.abortController.signal };
        this.motion.addEventListener('change', () => this.applyMotion(), options);
        this.addEventListener('click', (event) => {
          if (event.target.closest('.au-launch-demo__poster')) {
            const video = this.querySelector('deferred-media > video');
            if (!video) return;
            this.bindVideo(video);
            this.playVideo();
            this.toggle.focus({ preventScroll: true });
          } else if (event.target.closest('[data-demo-toggle]') && this.video) {
            if (this.video.paused) this.playVideo();
            else this.video.pause();
          }
        }, options);
        const existing = this.querySelector('deferred-media > video');
        if (existing) this.bindVideo(existing);
      }

      bindVideo(video) {
        if (this.video === video) return;
        this.video = video;
        const options = { signal: this.abortController.signal };
        ['play', 'pause', 'ended'].forEach((name) => {
          video.addEventListener(name, () => this.sync(), options);
        });
        video.addEventListener('error', () => {
          const focused = document.activeElement === this.toggle || document.activeElement === video;
          this.toggle.hidden = true;
          this.errorLink.hidden = false;
          if (focused) this.errorLink.querySelector('a').focus({ preventScroll: true });
        }, options);
        video.controls = false;
        video.tabIndex = -1;
        video.muted = true;
        video.playsInline = true;
        this.applyMotion();
        this.toggle.hidden = false;
        this.errorLink.hidden = true;
        this.sync();
      }

      applyMotion() {
        if (this.video) this.video.loop = !this.motion.matches;
      }

      async playVideo() {
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
        try {
          await this.video.play();
        } catch {
          this.sync();
        }
      }

      sync() {
        if (!this.video) return;
        const label = this.video.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        this.toggle.textContent = label;
        this.toggle.setAttribute('aria-label', `${label}: ${this.dataset.title}`);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.video?.pause();
        this.video = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["au-water-details"]) return;
  try {
    
  if (!customElements.get('au-water-details')) {
    customElements.define('au-water-details', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        if (!this.details || !this.summary) return;
        this.syncExpanded = () => this.summary.setAttribute('aria-expanded', String(this.details.open));
        this.reveal = () => {
          this.details.open = true;
          this.syncExpanded();
          this.summary.focus({ preventScroll: true });
          this.details.scrollIntoView({ block: 'start' });
        };
        this.onHashChange = () => {
          if (window.location.hash === '#au-water-details') this.reveal();
        };
        this.onLink = (event) => {
          const anchor = event.target instanceof Element ? event.target.closest('a') : null;
          if (anchor?.getAttribute('href') === '#au-water-details') this.reveal();
        };
        this.details.open = window.location.hash === '#au-water-details';
        this.syncExpanded();
        this.details.addEventListener('toggle', this.syncExpanded);
        document.addEventListener('click', this.onLink);
        window.addEventListener('hashchange', this.onHashChange);
        this.onHashChange();
      }
      disconnectedCallback() {
        this.details?.removeEventListener('toggle', this.syncExpanded);
        document.removeEventListener('click', this.onLink);
        window.removeEventListener('hashchange', this.onHashChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
